<template>
  <span>
    <svg
      v-if="icon === 'ewallet'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-4-Copy">
          <g id="Group-5-Copy">
            <circle
              id="Combined-Shape"
              fill="#06AE26"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
            <circle
              id="Oval"
              fill="#FFFFFF"
              cx="18.5"
              cy="18.5"
              r="14.3888889"
            ></circle>
            <path
              d="M17.9860929,26.8506892 C21.9071092,26.8506892 25.0841662,23.6736322 25.0841662,19.7526159 C25.0841662,18.3261828 24.6644311,16.9986933 23.9409669,15.8930518 L23.9614288,15.8725566 L24.9647275,14.8692912 C25.1251233,14.7088954 25.1251233,14.4495227 24.9647275,14.2891603 L23.9989867,13.3233861 C23.8385909,13.1630236 23.5792515,13.1630236 23.4188557,13.3233861 L22.4804085,14.2618333 C21.5248986,13.4769502 20.3578049,12.9377763 19.0781042,12.7398559 L19.0781042,11.5625312 L20.033614,11.5625312 C20.258828,11.5625312 20.4431183,11.378241 20.4431183,11.153027 L20.4431183,9.7880129 C20.4431183,9.56279891 20.258828,9.37850867 20.033614,9.37850867 L15.9385717,9.37850867 C15.7133577,9.37850867 15.5290675,9.56279891 15.5290675,9.7880129 L15.5290675,11.153027 C15.5290675,11.378241 15.7133577,11.5625312 15.9385717,11.5625312 L16.8940816,11.5625312 L16.8940816,12.7398559 C13.4917773,13.2619671 10.8880195,16.2035792 10.8880195,19.7526159 C10.8880195,23.6736322 14.0650765,26.8506892 17.9860929,26.8506892 Z M18.6685999,21.3906328 L17.3035858,21.3906328 C17.0783718,21.3906328 16.8940816,21.2063426 16.8940816,20.9811286 L16.8940816,15.8111376 C16.8940816,15.5859237 17.0783718,15.4016334 17.3035858,15.4016334 L18.6685999,15.4016334 C18.8938139,15.4016334 19.0781042,15.5859237 19.0781042,15.8111376 L19.0781042,20.9811286 C19.0781042,21.2063426 18.8938139,21.3906328 18.6685999,21.3906328 Z"
              id="S"
              fill="#06AE26"
              fill-rule="nonzero"
            ></path>
            <circle
              id="Combined-Shape-Copy-3"
              fill="#4AB762"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
          </g>
          <path
            d="M15.6562389,22.2500042 L17.9374835,15.9687691 L20.2499779,22.2500042 L21.499975,22.2500042 L24.4687179,14.1875234 L23.1874709,14.1875234 L20.8749765,20.7187578 L18.562482,14.1875234 L17.4062347,14.1875234 L15.0624903,20.6875079 L12.7812458,14.1875234 L11.437499,14.1875234 L14.4062419,22.2500042 L15.6562389,22.2500042 Z M25.4124717,24.9999976 C26.28808,24.9999976 26.9999619,24.3271782 26.9999619,23.5000012 L26.9999619,15.5000203 C26.9999619,14.6728433 26.28808,14.000031 25.4124717,14.000031 L13.5,14.000031 C13.2237496,14.000031 13,13.7762695 13,13.500031 C13,13.2237806 13.2237496,13.000031 13.5,13.000031 L25.4999654,13.000031 C25.7762099,13.000031 25.9999642,12.7762719 25.9999642,12.500031 C25.9999642,11.6715992 25.328396,11.000031 24.4999678,11.000031 L13,11.000031 C11.8953226,11.000031 11,11.8953536 11,13.000031 L11,23.0000024 C11,24.104675 11.8953226,24.9999976 13,24.9999976 L25.4124717,24.9999976 Z M23.9999714,20.5000131 C23.4477853,20.5000131 22.9999714,20.0521945 22.9999714,19.5000131 C22.9999714,18.947827 23.4477853,18.5000131 23.9999714,18.5000131 C24.5521527,18.5000131 24.9999714,18.947827 24.9999714,19.5000131 C24.9999714,20.0521945 24.5521527,20.5000131 23.9999714,20.5000131 Z"
            id="wwallet"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'critical-battery'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-24-Copy-2">
          <circle
            id="Combined-Shape-Copy-9"
            fill="#FF1515"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <path
            d="M27.2039475,23.5746554 C28.1086026,23.5746554 28.8419644,22.8412936 28.8419644,21.9366385 L28.8419644,21.3906328 L29.1149672,21.3906328 C29.5672948,21.3906328 29.9339757,21.0239519 29.9339757,20.5716243 L29.9339757,15.6575736 C29.9339757,15.205246 29.5672948,14.8385651 29.1149672,14.8385651 L28.8419644,14.8385651 L28.8419644,14.2925595 C28.8419644,13.3879044 28.1086026,12.6545425 27.2039475,12.6545425 L9.73176693,12.6545425 C8.82711183,12.6545425 8.09375,13.3879044 8.09375,14.2925595 L8.09375,21.9366385 C8.09375,22.8412936 8.82711183,23.5746554 9.73176693,23.5746554 L27.2039475,23.5746554 Z M26.6579419,21.3906328 L10.2777726,21.3906328 L10.2777726,14.8385651 L26.6579419,14.8385651 L26.6579419,17.0225877 L27.7499531,17.0225877 L27.7499531,19.2066102 L26.6579419,19.2066102 L26.6579419,21.3906328 Z M15.737829,20.2986215 L15.737829,15.9305764 L11.3697839,15.9305764 L11.3697839,20.2986215 L15.737829,20.2986215 Z"
            id="B"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'illegal-movement'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-39-Copy-5">
          <circle
            id="Combined-Shape-Copy-8"
            fill="#FF8400"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <path
            d="M25.8836295,25.8139535 C27.1502764,25.8139535 27.9463346,24.4697065 27.3121388,23.3943221 L19.0680963,9.41084501 C18.4347058,8.33690483 16.8455085,8.33493538 16.2110107,9.41084501 L7.96673342,23.3943221 C7.33377908,24.4676386 8.12617994,25.8139535 9.39527622,25.8139535 L25.8836295,25.8139535 Z M18.4735608,19.8982559 L16.8055463,19.8982559 C16.5865757,19.8982559 16.4057892,19.7307871 16.3938776,19.516905 L16.1390048,14.9456841 C16.1261202,14.714635 16.3141208,14.5203489 16.5506399,14.5203489 L18.7284336,14.5203489 C18.9649527,14.5203489 19.1529868,14.714635 19.1401023,14.9456841 L18.8852294,19.516905 C18.8733179,19.7307871 18.6925313,19.8982559 18.4735608,19.8982559 Z M17.6395535,23.5955669 C16.7666577,23.5955669 16.0590467,22.9033386 16.0590467,22.0494186 C16.0590467,21.1954987 16.7666577,20.5032704 17.6395535,20.5032704 C18.5124494,20.5032704 19.2200604,21.1954987 19.2200604,22.0494186 C19.2200604,22.9033386 18.5124494,23.5955669 17.6395535,23.5955669 Z"
            id="E"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'illegally-parked'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-5-Copy-4">
          <circle
            id="Combined-Shape"
            fill="#06AE26"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <circle
            id="Oval"
            fill="#FFFFFF"
            cx="18.5"
            cy="18.5"
            r="14.3888889"
          ></circle>
          <path
            d="M17.9860929,26.8506892 C21.9071092,26.8506892 25.0841662,23.6736322 25.0841662,19.7526159 C25.0841662,18.3261828 24.6644311,16.9986933 23.9409669,15.8930518 L23.9614288,15.8725566 L24.9647275,14.8692912 C25.1251233,14.7088954 25.1251233,14.4495227 24.9647275,14.2891603 L23.9989867,13.3233861 C23.8385909,13.1630236 23.5792515,13.1630236 23.4188557,13.3233861 L22.4804085,14.2618333 C21.5248986,13.4769502 20.3578049,12.9377763 19.0781042,12.7398559 L19.0781042,11.5625312 L20.033614,11.5625312 C20.258828,11.5625312 20.4431183,11.378241 20.4431183,11.153027 L20.4431183,9.7880129 C20.4431183,9.56279891 20.258828,9.37850867 20.033614,9.37850867 L15.9385717,9.37850867 C15.7133577,9.37850867 15.5290675,9.56279891 15.5290675,9.7880129 L15.5290675,11.153027 C15.5290675,11.378241 15.7133577,11.5625312 15.9385717,11.5625312 L16.8940816,11.5625312 L16.8940816,12.7398559 C13.4917773,13.2619671 10.8880195,16.2035792 10.8880195,19.7526159 C10.8880195,23.6736322 14.0650765,26.8506892 17.9860929,26.8506892 Z M18.6685999,21.3906328 L17.3035858,21.3906328 C17.0783718,21.3906328 16.8940816,21.2063426 16.8940816,20.9811286 L16.8940816,15.8111376 C16.8940816,15.5859237 17.0783718,15.4016334 17.3035858,15.4016334 L18.6685999,15.4016334 C18.8938139,15.4016334 19.0781042,15.5859237 19.0781042,15.8111376 L19.0781042,20.9811286 C19.0781042,21.2063426 18.8938139,21.3906328 18.6685999,21.3906328 Z"
            id="S"
            fill="#06AE26"
            fill-rule="nonzero"
          ></path>
          <circle
            id="Combined-Shape-Copy-3"
            fill="#068EFF"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <path
            d="M25.5338216,25.758678 C26.4381435,25.758678 27.1718386,25.0249829 27.1718386,24.120661 L27.1718386,12.1085369 C27.1718386,11.204215 26.4381435,10.47052 25.5338216,10.47052 L13.5216975,10.47052 C12.6173756,10.47052 11.8836806,11.204215 11.8836806,12.1085369 L11.8836806,24.120661 C11.8836806,25.0249829 12.6173756,25.758678 13.5216975,25.758678 L25.5338216,25.758678 Z M17.8897426,22.4826441 L16.7977313,22.4826441 C16.4974349,22.4826441 16.2517257,22.2369349 16.2517257,21.9366385 L16.2517257,14.2925595 C16.2517257,13.992263 16.4974349,13.7465538 16.7977313,13.7465538 L20.0737652,13.7465538 C21.8790097,13.7465538 23.3497991,15.2173432 23.3497991,17.0225877 C23.3497991,18.8278322 21.8790097,20.2986215 20.0737652,20.2986215 L18.4357483,20.2986215 L18.4357483,21.9366385 C18.4357483,22.2369349 18.1900391,22.4826441 17.8897426,22.4826441 Z M20.0737652,18.114599 C20.6743581,18.114599 21.1657765,17.6231805 21.1657765,17.0225877 C21.1657765,16.4219948 20.6743581,15.9305764 20.0737652,15.9305764 L18.4357483,15.9305764 L18.4357483,18.114599 L20.0737652,18.114599 Z"
            id="P"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'iot-removed'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-11-Copy-2">
          <circle
            id="Combined-Shape-Copy-11"
            fill="#FF1515"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <g
            id="Group-13"
            transform="translate(8.222222, 7.194444)"
            fill="#FFFFFF"
            fill-rule="nonzero"
          >
            <path
              d="M12.1405961,1.26101392 C12.1405961,0.603414766 12.7593337,0.115793508 13.3963494,0.279143542 C17.9099233,1.4365905 21.2460431,5.53178573 21.2460431,10.4062693 C21.2460431,16.1725502 16.5775996,20.8484861 10.8141592,20.8606543 C5.03668093,20.8728157 0.367702243,16.2398168 0.337215071,10.4624209 C0.31167417,5.56714805 3.65071682,1.44762322 8.17610556,0.281942888 C8.81736147,0.116740346 9.44268582,0.599174581 9.44268582,1.26138442 L9.44268582,1.26138442 L9.44268582,1.9631556 C9.44268582,2.41862555 9.13574584,2.81308624 8.69703079,2.93563993 C5.42895978,3.84847351 3.03514901,6.84546086 3.03514901,10.4062693 C3.03514901,14.6936313 6.50493756,18.1627612 10.7916409,18.1627612 C15.079003,18.1627612 18.5481329,14.6929727 18.5481329,10.4062693 C18.5481329,6.84492569 16.1539104,3.84839118 12.8861276,2.93563993 C12.447536,2.81308624 12.1405961,2.41870788 12.1405961,1.9632791 L12.1405961,1.9632791 Z M10.7916667,12.3333333 C11.6417475,12.3333333 12.3333333,13.0249191 12.3333333,13.875 C12.3333333,14.7250809 11.6417475,15.4166667 10.7916667,15.4166667 C9.9415858,15.4166667 9.25,14.7250809 9.25,13.875 C9.25,13.0249191 9.9415858,12.3333333 10.7916667,12.3333333 Z M11.8104922,5.13888889 C12.1095111,5.13888889 12.3475817,5.36031528 12.332669,5.62449883 L12.332669,5.62449883 L12.0363944,10.8661655 C12.0224816,11.1123015 11.7928353,11.3055556 11.5142389,11.3055556 L11.5142389,11.3055556 L10.0690944,11.3055556 C9.79049803,11.3055556 9.5608517,11.1123015 9.5469389,10.8661655 L9.5469389,10.8661655 L9.2506643,5.62449883 C9.23575164,5.36031528 9.47382224,5.13888889 9.77284111,5.13888889 L9.77284111,5.13888889 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'negative-balance'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-4-Copy">
          <g id="Group-5-Copy">
            <circle
              id="Combined-Shape"
              fill="#06AE26"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
            <circle
              id="Oval"
              fill="#FFFFFF"
              cx="18.5"
              cy="18.5"
              r="14.3888889"
            ></circle>
            <path
              d="M17.9860929,26.8506892 C21.9071092,26.8506892 25.0841662,23.6736322 25.0841662,19.7526159 C25.0841662,18.3261828 24.6644311,16.9986933 23.9409669,15.8930518 L23.9614288,15.8725566 L24.9647275,14.8692912 C25.1251233,14.7088954 25.1251233,14.4495227 24.9647275,14.2891603 L23.9989867,13.3233861 C23.8385909,13.1630236 23.5792515,13.1630236 23.4188557,13.3233861 L22.4804085,14.2618333 C21.5248986,13.4769502 20.3578049,12.9377763 19.0781042,12.7398559 L19.0781042,11.5625312 L20.033614,11.5625312 C20.258828,11.5625312 20.4431183,11.378241 20.4431183,11.153027 L20.4431183,9.7880129 C20.4431183,9.56279891 20.258828,9.37850867 20.033614,9.37850867 L15.9385717,9.37850867 C15.7133577,9.37850867 15.5290675,9.56279891 15.5290675,9.7880129 L15.5290675,11.153027 C15.5290675,11.378241 15.7133577,11.5625312 15.9385717,11.5625312 L16.8940816,11.5625312 L16.8940816,12.7398559 C13.4917773,13.2619671 10.8880195,16.2035792 10.8880195,19.7526159 C10.8880195,23.6736322 14.0650765,26.8506892 17.9860929,26.8506892 Z M18.6685999,21.3906328 L17.3035858,21.3906328 C17.0783718,21.3906328 16.8940816,21.2063426 16.8940816,20.9811286 L16.8940816,15.8111376 C16.8940816,15.5859237 17.0783718,15.4016334 17.3035858,15.4016334 L18.6685999,15.4016334 C18.8938139,15.4016334 19.0781042,15.5859237 19.0781042,15.8111376 L19.0781042,20.9811286 C19.0781042,21.2063426 18.8938139,21.3906328 18.6685999,21.3906328 Z"
              id="S"
              fill="#06AE26"
              fill-rule="nonzero"
            ></path>
            <circle
              id="Combined-Shape-Copy-3"
              fill="#4AB762"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
          </g>
          <path
            d="M15.6562389,22.2500042 L17.9374835,15.9687691 L20.2499779,22.2500042 L21.499975,22.2500042 L24.4687179,14.1875234 L23.1874709,14.1875234 L20.8749765,20.7187578 L18.562482,14.1875234 L17.4062347,14.1875234 L15.0624903,20.6875079 L12.7812458,14.1875234 L11.437499,14.1875234 L14.4062419,22.2500042 L15.6562389,22.2500042 Z M25.4124717,24.9999976 C26.28808,24.9999976 26.9999619,24.3271782 26.9999619,23.5000012 L26.9999619,15.5000203 C26.9999619,14.6728433 26.28808,14.000031 25.4124717,14.000031 L13.5,14.000031 C13.2237496,14.000031 13,13.7762695 13,13.500031 C13,13.2237806 13.2237496,13.000031 13.5,13.000031 L25.4999654,13.000031 C25.7762099,13.000031 25.9999642,12.7762719 25.9999642,12.500031 C25.9999642,11.6715992 25.328396,11.000031 24.4999678,11.000031 L13,11.000031 C11.8953226,11.000031 11,11.8953536 11,13.000031 L11,23.0000024 C11,24.104675 11.8953226,24.9999976 13,24.9999976 L25.4124717,24.9999976 Z M23.9999714,20.5000131 C23.4477853,20.5000131 22.9999714,20.0521945 22.9999714,19.5000131 C22.9999714,18.947827 23.4477853,18.5000131 23.9999714,18.5000131 C24.5521527,18.5000131 24.9999714,18.947827 24.9999714,19.5000131 C24.9999714,20.0521945 24.5521527,20.5000131 23.9999714,20.5000131 Z"
            id="wwallet"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'pull-up'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-37-Copy-5">
          <circle
            id="Combined-Shape-Copy-5"
            fill="#7C4EDB"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <path
            d="M26.9309473,22.0731399 L26.9309473,17.9756981 C28.0359222,17.6262798 28.841967,16.6048854 28.841967,15.3845707 L28.841967,14.2925595 C28.841967,13.9908967 28.5976242,13.7465538 28.2959614,13.7465538 L27.7499557,13.7465538 L27.7499557,12.1085369 C27.7499557,11.8068741 27.5056129,11.5625312 27.2039501,11.5625312 C26.9022873,11.5625312 26.6579445,11.8068741 26.6579445,12.1085369 L26.6579445,13.7465538 L25.5659332,13.7465538 L25.5659332,12.1085369 C25.5659332,11.8068741 25.3215903,11.5625312 25.0199275,11.5625312 C24.7182647,11.5625312 24.4739219,11.8068741 24.4739219,12.1085369 L24.4739219,13.7465538 L23.9279162,13.7465538 C23.6262535,13.7465538 23.3819106,13.9908967 23.3819106,14.2925595 L23.3819106,15.3845707 C23.3819106,16.6048854 24.1879554,17.6262798 25.2929303,17.9756981 L25.2929303,22.0192191 C25.2929303,22.4952745 24.9687395,22.937871 24.4991826,23.0153528 C23.9012891,23.1139631 23.3819106,22.6529376 23.3819106,22.0731399 L23.3819106,21.11763 C23.3819106,19.4591512 22.0373584,18.114599 20.3788796,18.114599 L20.1058767,18.114599 L20.1058767,11.5625312 C20.1058767,10.3562134 19.1281721,9.37850867 17.9218542,9.37850867 L12.4617977,9.37850867 C11.2554799,9.37850867 10.2777752,10.3562134 10.2777752,11.5625312 L10.2777752,23.5746554 L20.1058767,23.5746554 L20.1058767,19.7526159 L20.3788796,19.7526159 C21.1327033,19.7526159 21.7438937,20.3638063 21.7438937,21.11763 L21.7438937,21.9574669 C21.7438937,23.311217 22.7307962,24.5223004 24.0784144,24.653703 C25.6242862,24.8048677 26.9309473,23.5886521 26.9309473,22.0731399 Z M14.5093189,20.2986215 C14.2475801,20.2986215 14.0496597,20.084305 14.1110787,19.8577246 L14.8966283,17.0225877 L12.871302,17.0225877 C12.6238932,17.0225877 12.4328045,16.8318323 12.4655635,16.6168492 L13.0115692,12.9654365 C13.0385295,12.7876447 13.211889,12.6545425 13.4173076,12.6545425 L15.7378316,12.6545425 C16.0067354,12.6545425 16.2026229,12.8777237 16.1336724,13.1053371 L15.7378316,14.8385651 L17.7068711,14.8385651 C18.0221974,14.8385651 18.2190847,15.138195 18.0614215,15.3763727 L14.8638693,20.1197967 C14.7888202,20.2334368 14.6519522,20.2986215 14.5093189,20.2986215 Z M20.6518824,26.8506892 C20.9535452,26.8506892 21.197888,26.6063464 21.197888,26.3046836 L21.197888,25.2126723 C21.197888,24.9110095 20.9535452,24.6666667 20.6518824,24.6666667 L9.73176953,24.6666667 C9.43010675,24.6666667 9.18576389,24.9110095 9.18576389,25.2126723 L9.18576389,26.3046836 C9.18576389,26.6063464 9.43010675,26.8506892 9.73176953,26.8506892 L20.6518824,26.8506892 Z"
            id="C"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'retricted-area'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-38-Copy-4">
          <circle
            id="Combined-Shape-Copy-7"
            fill="#D00447"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <path
            d="M14.924469,24.0311726 L18.3394037,20.6162379 L21.7543384,24.0311726 C22.1733738,24.4502413 22.8531481,24.4502413 23.2722168,24.0311726 L24.0311726,23.2722168 C24.4502413,22.8531481 24.4502413,22.1737404 24.0311726,21.7543384 L20.6162379,18.3394037 L24.0311726,14.924469 C24.4502413,14.5054337 24.4502413,13.8259926 24.0311726,13.4065907 L23.2722168,12.6476348 C22.8531481,12.2285662 22.1737404,12.2285662 21.7543384,12.6476348 L18.3394037,16.0625695 L14.924469,12.6476348 C14.5054337,12.2285662 13.8259926,12.2285662 13.4065907,12.6476348 L12.6476348,13.4065907 C12.2285662,13.8256593 12.2285662,14.5050671 12.6476348,14.924469 L16.0625695,18.3394037 L12.6476348,21.7543384 C12.2285662,22.1733738 12.2285662,22.8528149 12.6476348,23.2722168 L13.4065907,24.0311726 C13.8256593,24.4502413 14.5054337,24.4502413 14.924469,24.0311726 Z"
            id="T"
            fill="#FFFFFF"
            fill-rule="nonzero"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'fallen-down'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-23-Copy">
          <g id="Group-22-Copy">
            <g id="Group-5-Copy">
              <circle
                id="Combined-Shape"
                fill="#06AE26"
                cx="18.5"
                cy="18.5"
                r="18.5"
              ></circle>
              <circle
                id="Oval"
                fill="#FFFFFF"
                cx="18.5"
                cy="18.5"
                r="14.3888889"
              ></circle>
              <path
                d="M17.9860929,26.8506892 C21.9071092,26.8506892 25.0841662,23.6736322 25.0841662,19.7526159 C25.0841662,18.3261828 24.6644311,16.9986933 23.9409669,15.8930518 L23.9614288,15.8725566 L24.9647275,14.8692912 C25.1251233,14.7088954 25.1251233,14.4495227 24.9647275,14.2891603 L23.9989867,13.3233861 C23.8385909,13.1630236 23.5792515,13.1630236 23.4188557,13.3233861 L22.4804085,14.2618333 C21.5248986,13.4769502 20.3578049,12.9377763 19.0781042,12.7398559 L19.0781042,11.5625312 L20.033614,11.5625312 C20.258828,11.5625312 20.4431183,11.378241 20.4431183,11.153027 L20.4431183,9.7880129 C20.4431183,9.56279891 20.258828,9.37850867 20.033614,9.37850867 L15.9385717,9.37850867 C15.7133577,9.37850867 15.5290675,9.56279891 15.5290675,9.7880129 L15.5290675,11.153027 C15.5290675,11.378241 15.7133577,11.5625312 15.9385717,11.5625312 L16.8940816,11.5625312 L16.8940816,12.7398559 C13.4917773,13.2619671 10.8880195,16.2035792 10.8880195,19.7526159 C10.8880195,23.6736322 14.0650765,26.8506892 17.9860929,26.8506892 Z M18.6685999,21.3906328 L17.3035858,21.3906328 C17.0783718,21.3906328 16.8940816,21.2063426 16.8940816,20.9811286 L16.8940816,15.8111376 C16.8940816,15.5859237 17.0783718,15.4016334 17.3035858,15.4016334 L18.6685999,15.4016334 C18.8938139,15.4016334 19.0781042,15.5859237 19.0781042,15.8111376 L19.0781042,20.9811286 C19.0781042,21.2063426 18.8938139,21.3906328 18.6685999,21.3906328 Z"
                id="S"
                fill="#06AE26"
                fill-rule="nonzero"
              ></path>
              <circle
                id="Combined-Shape-Copy-3"
                fill="#B24EF9"
                cx="18.5"
                cy="18.5"
                r="18.5"
              ></circle>
            </g>
            <path
              d="M29,25.6698862 L28.9097841,25.1775501 C28.8195682,24.6852141 28.6307327,24.2150578 28.3598379,23.8055537 C28.3579841,23.5284435 28.1808891,23.2153254 27.8571005,22.9497159 C27.6196967,22.7550269 27.3620253,22.6434435 27.1500797,22.6434435 C27.114982,22.6434435 27.082356,22.6463186 27.0520781,22.6515213 C26.6547573,22.4614872 26.2342029,22.3653749 25.7994365,22.3653749 C24.5554457,22.3653749 23.4308365,23.1758948 22.917471,24.4122113 L16.8926554,24.5339262 C16.6175587,24.3197956 16.3823795,24.051174 16.1929261,23.7346332 L13.8382911,19.784855 L15.0549699,13.7217012 C15.2114265,13.6618706 15.3435372,13.5335839 15.4155863,13.3618961 C15.4357304,13.3135661 15.4501897,13.2663314 15.4598292,13.2163585 C15.46848,13.1715882 15.4730526,13.1257227 15.473547,13.0794464 C15.47503,12.8994069 15.413609,12.7285406 15.3006538,12.5982002 C15.2398507,12.5282381 15.1673072,12.473884 15.0871016,12.438013 L15.6018266,9.87255347 L15.8620933,9.8999359 C15.8675309,9.90007281 15.872845,9.90020972 15.8782827,9.90020972 C16.253482,9.90020972 16.5586094,9.56203675 16.5586094,9.14637152 C16.5586094,9.00685805 16.5227702,8.87295799 16.4581361,8.75562429 L14.6037668,7.00232751 C14.5854765,7.00082147 14.5670625,7 14.548525,7 C14.1519458,7 13.8292695,7.35747758 13.8292695,7.79696553 L13.8292695,7.9670104 L14.6567841,8.95825425 L14.0076004,12.1930772 C13.8157989,12.2017027 13.6373444,12.3091787 13.5257486,12.4851108 C13.4782926,12.5605494 13.4452958,12.6443396 13.4279941,12.734154 C13.4184782,12.7828947 13.4140292,12.8343737 13.4146471,12.8864003 C13.4166244,13.0750652 13.4862019,13.2464792 13.6006402,13.3697001 L11.894571,21.8715329 L12.0285354,21.9034334 C12.0001112,22.0328153 11.9662494,22.1698644 11.9262083,22.3186879 C11.9061878,22.390156 11.8860437,22.4616242 11.8647874,22.5328185 C11.7751894,22.524193 11.6858386,22.5199487 11.5972293,22.5199487 C11.0698988,22.5199487 10.5477588,22.6667185 10.087287,22.9445132 L9.7217272,23.1650787 L10.0636825,23.7024588 C9.3989273,24.2391544 9,25.0923908 9,26.0229826 C9,27.6093835 10.1651445,28.9001911 11.5972293,28.9001911 C12.5659997,28.9001911 13.4572834,28.2884676 13.8998356,27.3485658 L14.5061359,27.4382433 L14.6020367,27.1138984 C14.7063411,26.7612128 14.7593584,26.3942883 14.7593584,26.0229826 C14.7593584,25.5395458 14.6688953,25.0670621 14.4990917,24.6327768 L14.894435,25.3244569 C15.1130541,25.7095907 15.385432,26.0384536 15.7040301,26.3021464 C15.9037409,26.4675363 16.1218656,26.6047222 16.3527195,26.7102815 C16.4185894,26.7404021 16.4853245,26.7677846 16.5525539,26.7921549 C16.5822139,26.8028341 16.6121211,26.8132394 16.6421518,26.8229602 C16.7984849,26.8733438 16.9561773,26.9083933 17.1112745,26.9272872 C17.158607,26.9330375 17.2066809,26.9375556 17.2553728,26.9407046 L17.2695849,26.941663 L23.0333922,26.8117334 C23.4340497,28.1156845 24.5317177,29 25.7994365,29 C27.4128181,29 28.7255212,27.5458562 28.7255212,25.7583314 C28.7255212,25.7288953 28.7250269,25.6994592 28.7242854,25.6698862 L29,25.6698862 Z"
              id="Path"
              fill="#FFFFFF"
            ></path>
          </g>
          <path
            d="M25.4669443,15.8236468 L28.1969725,13.0936186 C28.5167977,12.7737934 28.5167977,12.255248 28.1969725,11.9353895 L25.4669443,9.20536125 C24.9526313,8.6910482 24.0688046,9.05532967 24.0688046,9.78449248 L24.0688046,11.4225094 L19.8543393,11.4225094 C19.4020117,11.4225094 19.0353308,11.7891903 19.0353308,12.2415179 L19.0353308,12.7875235 C19.0353308,13.2398511 19.4020117,13.606532 19.8543393,13.606532 L24.0688046,13.606532 L24.0688046,15.2445489 C24.0688046,15.9767443 24.9545641,16.3359603 25.4669443,15.8236468 Z"
            id="E"
            fill="#FFFFFF"
            fill-rule="nonzero"
            transform="translate(23.736086, 12.514386) rotate(-270.000000) translate(-23.736086, -12.514386) "
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'idle-vehicle'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-22">
          <g id="Group-5-Copy">
            <circle
              id="Combined-Shape"
              fill="#06AE26"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
            <circle
              id="Oval"
              fill="#FFFFFF"
              cx="18.5"
              cy="18.5"
              r="14.3888889"
            ></circle>
            <path
              d="M17.9860929,26.8506892 C21.9071092,26.8506892 25.0841662,23.6736322 25.0841662,19.7526159 C25.0841662,18.3261828 24.6644311,16.9986933 23.9409669,15.8930518 L23.9614288,15.8725566 L24.9647275,14.8692912 C25.1251233,14.7088954 25.1251233,14.4495227 24.9647275,14.2891603 L23.9989867,13.3233861 C23.8385909,13.1630236 23.5792515,13.1630236 23.4188557,13.3233861 L22.4804085,14.2618333 C21.5248986,13.4769502 20.3578049,12.9377763 19.0781042,12.7398559 L19.0781042,11.5625312 L20.033614,11.5625312 C20.258828,11.5625312 20.4431183,11.378241 20.4431183,11.153027 L20.4431183,9.7880129 C20.4431183,9.56279891 20.258828,9.37850867 20.033614,9.37850867 L15.9385717,9.37850867 C15.7133577,9.37850867 15.5290675,9.56279891 15.5290675,9.7880129 L15.5290675,11.153027 C15.5290675,11.378241 15.7133577,11.5625312 15.9385717,11.5625312 L16.8940816,11.5625312 L16.8940816,12.7398559 C13.4917773,13.2619671 10.8880195,16.2035792 10.8880195,19.7526159 C10.8880195,23.6736322 14.0650765,26.8506892 17.9860929,26.8506892 Z M18.6685999,21.3906328 L17.3035858,21.3906328 C17.0783718,21.3906328 16.8940816,21.2063426 16.8940816,20.9811286 L16.8940816,15.8111376 C16.8940816,15.5859237 17.0783718,15.4016334 17.3035858,15.4016334 L18.6685999,15.4016334 C18.8938139,15.4016334 19.0781042,15.5859237 19.0781042,15.8111376 L19.0781042,20.9811286 C19.0781042,21.2063426 18.8938139,21.3906328 18.6685999,21.3906328 Z"
              id="S"
              fill="#06AE26"
              fill-rule="nonzero"
            ></path>
            <circle
              id="Combined-Shape-Copy-3"
              fill="#9B9B9B"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
          </g>
          <path
            d="M29,25.6698862 L28.9097841,25.1775501 C28.8195682,24.6852141 28.6307327,24.2150578 28.3598379,23.8055537 C28.3579841,23.5284435 28.1808891,23.2153254 27.8571005,22.9497159 C27.6196967,22.7550269 27.3620253,22.6434435 27.1500797,22.6434435 C27.114982,22.6434435 27.082356,22.6463186 27.0520781,22.6515213 C26.6547573,22.4614872 26.2342029,22.3653749 25.7994365,22.3653749 C24.5554457,22.3653749 23.4308365,23.1758948 22.917471,24.4122113 L16.8926554,24.5339262 C16.6175587,24.3197956 16.3823795,24.051174 16.1929261,23.7346332 L13.8382911,19.784855 L15.0549699,13.7217012 C15.2114265,13.6618706 15.3435372,13.5335839 15.4155863,13.3618961 C15.4357304,13.3135661 15.4501897,13.2663314 15.4598292,13.2163585 C15.46848,13.1715882 15.4730526,13.1257227 15.473547,13.0794464 C15.47503,12.8994069 15.413609,12.7285406 15.3006538,12.5982002 C15.2398507,12.5282381 15.1673072,12.473884 15.0871016,12.438013 L15.6018266,9.87255347 L15.8620933,9.8999359 C15.8675309,9.90007281 15.872845,9.90020972 15.8782827,9.90020972 C16.253482,9.90020972 16.5586094,9.56203675 16.5586094,9.14637152 C16.5586094,9.00685805 16.5227702,8.87295799 16.4581361,8.75562429 L14.6037668,7.00232751 C14.5854765,7.00082147 14.5670625,7 14.548525,7 C14.1519458,7 13.8292695,7.35747758 13.8292695,7.79696553 L13.8292695,7.9670104 L14.6567841,8.95825425 L14.0076004,12.1930772 C13.8157989,12.2017027 13.6373444,12.3091787 13.5257486,12.4851108 C13.4782926,12.5605494 13.4452958,12.6443396 13.4279941,12.734154 C13.4184782,12.7828947 13.4140292,12.8343737 13.4146471,12.8864003 C13.4166244,13.0750652 13.4862019,13.2464792 13.6006402,13.3697001 L11.894571,21.8715329 L12.0285354,21.9034334 C12.0001112,22.0328153 11.9662494,22.1698644 11.9262083,22.3186879 C11.9061878,22.390156 11.8860437,22.4616242 11.8647874,22.5328185 C11.7751894,22.524193 11.6858386,22.5199487 11.5972293,22.5199487 C11.0698988,22.5199487 10.5477588,22.6667185 10.087287,22.9445132 L9.7217272,23.1650787 L10.0636825,23.7024588 C9.3989273,24.2391544 9,25.0923908 9,26.0229826 C9,27.6093835 10.1651445,28.9001911 11.5972293,28.9001911 C12.5659997,28.9001911 13.4572834,28.2884676 13.8998356,27.3485658 L14.5061359,27.4382433 L14.6020367,27.1138984 C14.7063411,26.7612128 14.7593584,26.3942883 14.7593584,26.0229826 C14.7593584,25.5395458 14.6688953,25.0670621 14.4990917,24.6327768 L14.894435,25.3244569 C15.1130541,25.7095907 15.385432,26.0384536 15.7040301,26.3021464 C15.9037409,26.4675363 16.1218656,26.6047222 16.3527195,26.7102815 C16.4185894,26.7404021 16.4853245,26.7677846 16.5525539,26.7921549 C16.5822139,26.8028341 16.6121211,26.8132394 16.6421518,26.8229602 C16.7984849,26.8733438 16.9561773,26.9083933 17.1112745,26.9272872 C17.158607,26.9330375 17.2066809,26.9375556 17.2553728,26.9407046 L17.2695849,26.941663 L23.0333922,26.8117334 C23.4340497,28.1156845 24.5317177,29 25.7994365,29 C27.4128181,29 28.7255212,27.5458562 28.7255212,25.7583314 C28.7255212,25.7288953 28.7250269,25.6994592 28.7242854,25.6698862 L29,25.6698862 Z"
            id="Path"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'low-speed-zone'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-31">
          <g id="Group-5-Copy-4">
            <circle
              id="Combined-Shape"
              fill="#06AE26"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
            <circle
              id="Oval"
              fill="#FFFFFF"
              cx="18.5"
              cy="18.5"
              r="14.3888889"
            ></circle>
            <path
              d="M17.9860929,26.8506892 C21.9071092,26.8506892 25.0841662,23.6736322 25.0841662,19.7526159 C25.0841662,18.3261828 24.6644311,16.9986933 23.9409669,15.8930518 L23.9614288,15.8725566 L24.9647275,14.8692912 C25.1251233,14.7088954 25.1251233,14.4495227 24.9647275,14.2891603 L23.9989867,13.3233861 C23.8385909,13.1630236 23.5792515,13.1630236 23.4188557,13.3233861 L22.4804085,14.2618333 C21.5248986,13.4769502 20.3578049,12.9377763 19.0781042,12.7398559 L19.0781042,11.5625312 L20.033614,11.5625312 C20.258828,11.5625312 20.4431183,11.378241 20.4431183,11.153027 L20.4431183,9.7880129 C20.4431183,9.56279891 20.258828,9.37850867 20.033614,9.37850867 L15.9385717,9.37850867 C15.7133577,9.37850867 15.5290675,9.56279891 15.5290675,9.7880129 L15.5290675,11.153027 C15.5290675,11.378241 15.7133577,11.5625312 15.9385717,11.5625312 L16.8940816,11.5625312 L16.8940816,12.7398559 C13.4917773,13.2619671 10.8880195,16.2035792 10.8880195,19.7526159 C10.8880195,23.6736322 14.0650765,26.8506892 17.9860929,26.8506892 Z M18.6685999,21.3906328 L17.3035858,21.3906328 C17.0783718,21.3906328 16.8940816,21.2063426 16.8940816,20.9811286 L16.8940816,15.8111376 C16.8940816,15.5859237 17.0783718,15.4016334 17.3035858,15.4016334 L18.6685999,15.4016334 C18.8938139,15.4016334 19.0781042,15.5859237 19.0781042,15.8111376 L19.0781042,20.9811286 C19.0781042,21.2063426 18.8938139,21.3906328 18.6685999,21.3906328 Z"
              id="S"
              fill="#06AE26"
              fill-rule="nonzero"
            ></path>
            <circle
              id="Combined-Shape-Copy-3"
              fill="#29B12E"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
          </g>
          <g
            id="races"
            transform="translate(19.000000, 18.500000) scale(-1, 1) translate(-19.000000, -18.500000) translate(8.000000, 9.000000)"
            fill="#FFFFFF"
            fill-rule="nonzero"
          >
            <path
              d="M15.2557776,7.46133194 C14.8651917,7.0706171 14.2317464,7.07074601 13.8410745,7.46133194 L10.9884221,10.3138984 C10.8472268,10.2804257 10.7001878,10.2622069 10.5488518,10.2622069 C9.49891041,10.2622069 8.64464869,11.1171562 8.64464869,12.1681288 C8.64464869,13.2191015 9.49886744,14.0740937 10.5488518,14.0740937 C11.5998245,14.0740937 12.4548167,13.2190585 12.4548167,12.1681288 C12.4548167,12.0167929 12.4365979,11.8697538 12.4031253,11.7285585 L15.2556917,8.8759921 C15.6464924,8.48540616 15.6464924,7.85196085 15.2557776,7.46133194 Z"
              id="Path"
              transform="translate(12.096726, 10.621219) rotate(28.000000) translate(-12.096726, -10.621219) "
            ></path>
            <path
              d="M18.7808672,3.22686719 C14.4912109,-1.06291797 7.5095625,-1.06313281 3.21741406,3.22708203 C-0.487050781,6.9334375 -1.06111328,12.7796367 1.85229687,17.1279883 C2.15978125,17.5869375 2.78128125,17.7095703 3.24023047,17.4022148 C3.69917969,17.0947305 3.82198437,16.4733164 3.51445703,16.0142813 C2.69585937,14.7924648 2.21379297,13.4260156 2.05669922,12.0355039 L2.99724219,12.0355039 C3.54969141,12.0355039 3.99759766,11.5875977 3.99759766,11.0351484 C3.99759766,10.4826992 3.54969141,10.034793 2.99724219,10.034793 L2.05351953,10.034793 C2.23480469,8.37297656 2.87465234,6.75980078 3.95325391,5.40301953 L4.63387891,6.08373047 C4.82921484,6.27906641 5.08522266,6.37677734 5.34127344,6.37677734 C5.59728125,6.37677734 5.85333203,6.27906641 6.04858203,6.08373047 C6.43925391,5.69314453 6.43925391,5.05969922 6.04858203,4.66902734 L5.36482031,3.98539453 C6.74214062,2.87916406 8.37164453,2.23751172 10.041625,2.06039453 L10.041625,3.00510547 C10.041625,3.55755469 10.4895312,4.00546094 11.0419805,4.00546094 C11.5944297,4.00546094 12.0423359,3.55755469 12.0423359,3.00510547 L12.0423359,2.06946094 C13.6830117,2.25903906 15.2808477,2.89794141 16.6345781,3.98578125 L15.951332,4.66907031 C15.5607461,5.05974219 15.5607891,5.69310156 15.951418,6.08381641 C16.1467969,6.27915234 16.4027617,6.37677734 16.6588125,6.37677734 C16.9148633,6.37677734 17.1709141,6.27906641 17.366207,6.08373047 L18.0462305,5.40370703 C19.1250469,6.76035938 19.7650664,8.37332031 19.9464805,10.0348359 L19.0028437,10.0348359 C18.4503945,10.0348359 18.0024883,10.4827422 18.0024883,11.0351914 C18.0024883,11.5876406 18.4503945,12.0355469 19.0028437,12.0355469 L19.9434297,12.0355469 C19.78625,13.4260156 19.3040547,14.7923789 18.4851992,16.0141953 C18.1776289,16.4731445 18.3002617,17.0945156 18.759168,17.4020859 C18.9302266,17.5167266 19.1237578,17.5715977 19.3152266,17.5715977 C19.6376211,17.5715977 19.9541289,17.4160078 20.1471016,17.1281172 C23.0616719,12.7794219 22.4871367,6.93309375 18.7808672,3.22686719 Z"
              id="Path"
            ></path>
            <path
              d="M15.5084102,16.1226055 L6.491375,16.1226055 C5.93892578,16.1226055 5.49101953,16.5705117 5.49101953,17.1229609 C5.49101953,17.6754102 5.93892578,18.1233164 6.491375,18.1233164 L15.5084102,18.1233164 C16.0608594,18.1233164 16.5087656,17.6754102 16.5087656,17.1229609 C16.5087656,16.5705117 16.0608594,16.1226055 15.5084102,16.1226055 Z"
              id="Path"
            ></path>
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'out-of-service-area'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-11-Copy-2">
          <circle
            id="Combined-Shape-Copy-11"
            fill="#FF1515"
            cx="18.5"
            cy="18.5"
            r="18.5"
          ></circle>
          <g
            id="Group-13"
            transform="translate(8.222222, 7.194444)"
            fill="#FFFFFF"
            fill-rule="nonzero"
          >
            <path
              d="M12.1405961,1.26101392 C12.1405961,0.603414766 12.7593337,0.115793508 13.3963494,0.279143542 C17.9099233,1.4365905 21.2460431,5.53178573 21.2460431,10.4062693 C21.2460431,16.1725502 16.5775996,20.8484861 10.8141592,20.8606543 C5.03668093,20.8728157 0.367702243,16.2398168 0.337215071,10.4624209 C0.31167417,5.56714805 3.65071682,1.44762322 8.17610556,0.281942888 C8.81736147,0.116740346 9.44268582,0.599174581 9.44268582,1.26138442 L9.44268582,1.26138442 L9.44268582,1.9631556 C9.44268582,2.41862555 9.13574584,2.81308624 8.69703079,2.93563993 C5.42895978,3.84847351 3.03514901,6.84546086 3.03514901,10.4062693 C3.03514901,14.6936313 6.50493756,18.1627612 10.7916409,18.1627612 C15.079003,18.1627612 18.5481329,14.6929727 18.5481329,10.4062693 C18.5481329,6.84492569 16.1539104,3.84839118 12.8861276,2.93563993 C12.447536,2.81308624 12.1405961,2.41870788 12.1405961,1.9632791 L12.1405961,1.9632791 Z M10.7916667,12.3333333 C11.6417475,12.3333333 12.3333333,13.0249191 12.3333333,13.875 C12.3333333,14.7250809 11.6417475,15.4166667 10.7916667,15.4166667 C9.9415858,15.4166667 9.25,14.7250809 9.25,13.875 C9.25,13.0249191 9.9415858,12.3333333 10.7916667,12.3333333 Z M11.8104922,5.13888889 C12.1095111,5.13888889 12.3475817,5.36031528 12.332669,5.62449883 L12.332669,5.62449883 L12.0363944,10.8661655 C12.0224816,11.1123015 11.7928353,11.3055556 11.5142389,11.3055556 L11.5142389,11.3055556 L10.0690944,11.3055556 C9.79049803,11.3055556 9.5608517,11.1123015 9.5469389,10.8661655 L9.5469389,10.8661655 L9.2506643,5.62449883 C9.23575164,5.36031528 9.47382224,5.13888889 9.77284111,5.13888889 L9.77284111,5.13888889 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'report-from-user-app'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-34">
          <g id="Group-39-Copy-6" fill="#FF8400">
            <circle
              id="Combined-Shape-Copy-8"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
          </g>
          <path
            d="M23,7 C24.1045695,7 25,7.8954305 25,9 L25,27 C25,28.1045695 24.1045695,29 23,29 L14,29 C12.8954305,29 12,28.1045695 12,27 L12,9 C12,7.8954305 12.8954305,7 14,7 L23,7 Z M18.5805069,18.9829215 C17.707611,18.9829215 17,19.6751497 17,20.5290697 C17,21.3829897 17.707611,22.0752179 18.5805069,22.0752179 C19.4534027,22.0752179 20.1610137,21.3829897 20.1610137,20.5290697 C20.1610137,19.6751497 19.4534027,18.9829215 18.5805069,18.9829215 Z M19.669387,13 L17.4915932,13 C17.2550742,13 17.0670736,13.1942861 17.0799581,13.4253352 L17.0799581,13.4253352 L17.334831,17.9965561 C17.3467425,18.2104382 17.5275291,18.3779069 17.7464996,18.3779069 L17.7464996,18.3779069 L19.4145141,18.3779069 C19.6334847,18.3779069 19.8142712,18.2104382 19.8261828,17.9965561 L19.8261828,17.9965561 L20.0810556,13.4253352 C20.0939402,13.1942861 19.905906,13 19.669387,13 L19.669387,13 Z"
            id="Combined-Shape"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'restricted-area'"
      :class="customClass"
      width="37px"
      height="37px"
      viewBox="0 0 37 37"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
    >
      <g
        id="Page-1"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <g id="Group-34">
          <g id="Group-39-Copy-6" fill="#FF8400">
            <circle
              id="Combined-Shape-Copy-8"
              cx="18.5"
              cy="18.5"
              r="18.5"
            ></circle>
          </g>
          <path
            d="M23,7 C24.1045695,7 25,7.8954305 25,9 L25,27 C25,28.1045695 24.1045695,29 23,29 L14,29 C12.8954305,29 12,28.1045695 12,27 L12,9 C12,7.8954305 12.8954305,7 14,7 L23,7 Z M18.5805069,18.9829215 C17.707611,18.9829215 17,19.6751497 17,20.5290697 C17,21.3829897 17.707611,22.0752179 18.5805069,22.0752179 C19.4534027,22.0752179 20.1610137,21.3829897 20.1610137,20.5290697 C20.1610137,19.6751497 19.4534027,18.9829215 18.5805069,18.9829215 Z M19.669387,13 L17.4915932,13 C17.2550742,13 17.0670736,13.1942861 17.0799581,13.4253352 L17.0799581,13.4253352 L17.334831,17.9965561 C17.3467425,18.2104382 17.5275291,18.3779069 17.7464996,18.3779069 L17.7464996,18.3779069 L19.4145141,18.3779069 C19.6334847,18.3779069 19.8142712,18.2104382 19.8261828,17.9965561 L19.8261828,17.9965561 L20.0810556,13.4253352 C20.0939402,13.1942861 19.905906,13 19.669387,13 L19.669387,13 Z"
            id="Combined-Shape"
            fill="#FFFFFF"
          ></path>
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'times-circle'"
      :class="customClass"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g fill="none" fill-rule="evenodd">
        <g fill="#323841">
          <path
            d="M1587.769 2925.954l-2.046 2.046 2.046 2.046c.199.199.199.522 0 .721-.1.1-.231.15-.362.15-.13 0-.26-.05-.361-.15l-2.046-2.046-2.046 2.046c-.1.1-.231.15-.36.15-.132 0-.263-.05-.363-.15-.199-.199-.199-.522 0-.72l2.046-2.047-2.046-2.046c-.199-.199-.199-.522 0-.722.2-.2.523-.2.723 0l2.046 2.046 2.046-2.046c.2-.2.524-.198.723 0 .199.2.199.523 0 .722M1585 2936c-4.412 0-8-3.589-8-8s3.588-8 8-8 8 3.589 8 8-3.588 8-8 8"
            transform="translate(-1577 -2920)"
          />
        </g>
      </g>
    </svg>
    <svg
      v-else-if="icon === 'report-doc-verification'"
      :class="customClass"
      width="37"
      height="37"
      viewBox="0 0 37 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_1189_1749)">
        <circle cx="18.5" cy="18.5" r="18.5" fill="#E52E40" />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27 18C27 20.7615 29.2385 23 32 23C34.7615 23 37 20.7615 37 18C37 15.2385 34.7615 13 32 13C29.2385 13 27 15.2385 27 18ZM34.8284 20.8284C34.0783 21.5786 33.0609 22 32 22C30.9391 22 29.9217 21.5786 29.1716 20.8284C28.4214 20.0783 28 19.0609 28 18C28 16.9391 28.4214 15.9217 29.1716 15.1716C29.9217 14.4214 30.9391 14 32 14C33.0609 14 34.0783 14.4214 34.8284 15.1716C35.5786 15.9217 36 16.9391 36 18C36 19.0609 35.5786 20.0783 34.8284 20.8284ZM30.2615 20.4455L34.4455 16.2615C34.2508 15.9882 34.0118 15.7492 33.7385 15.5545L29.5545 19.7385C29.7492 20.0118 29.9882 20.2508 30.2615 20.4455ZM15 31.4762V33H27V31.4762C27 30.4658 26.6049 29.4969 25.9017 28.7825C25.1984 28.068 24.2446 27.6667 23.25 27.6667H18.75C17.7554 27.6667 16.8016 28.068 16.0983 28.7825C15.3951 29.4969 15 30.4658 15 31.4762ZM19.2779 25.7949C19.8239 26.0246 20.4091 26.1429 21 26.1429C22.1935 26.1429 23.3381 25.6612 24.182 24.8039C25.0259 23.9466 25.5 22.7838 25.5 21.5714C25.5 20.359 25.0259 19.1962 24.182 18.3389C23.3381 17.4816 22.1935 17 21 17C20.4091 17 19.8239 17.1182 19.2779 17.348C18.732 17.5777 18.2359 17.9144 17.818 18.3389C17.4002 18.7634 17.0687 19.2674 16.8425 19.822C16.6164 20.3766 16.5 20.9711 16.5 21.5714C16.5 22.1718 16.6164 22.7662 16.8425 23.3208C17.0687 23.8755 17.4002 24.3794 17.818 24.8039C18.2359 25.2284 18.732 25.5651 19.2779 25.7949Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_d_1189_1749"
          x="0"
          y="0"
          width="37"
          height="37"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 100 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.167222 0 0 0 0 0.193667 0 0 0 0 0.233333 0 0 0 0.17 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1189_1749"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1189_1749"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
    <img
      src="@/assets/img/illegal-demolished.png"
      v-if="icon === 'illegal-demolished'"
      :class="customClass"
      width="37px"
    />
    <img
      src="@/assets/img/suspicious-unlocked.png"
      v-if="icon === 'suspicious-unlocked'"
      :class="customClass"
      width="37px"
    />
  </span>
</template>
<script>
export default {
  props: {
    icon: String,
    customClass: {
      type: String,
      default: 'opacity-100',
    },
    color: String,
    height: {
      type: String,
      default: '1.2em',
    },
  },
  computed: {
    trueColor() {
      const predefinedColor = {
        secondary: '#66676c',
      }
      if (typeof this.color !== 'undefined') {
        return typeof predefinedColor[this.color] !== 'undefined'
          ? predefinedColor[this.color]
          : this.color
      } else {
        return '#343a40' // default text color
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
